export default  {
  Message: "Message",
  Notification: "Notification"
};
